module.exports = __webpack_public_path__ + "media/fangtan2.aa25b7d0.mp4";